/** 代理等级 dict_code → Tag 颜色 */
export const getAgentLevelTagColor = (levelCode: string): string => {
  if (levelCode.includes("province")) return "orange";
  if (levelCode.includes("city")) return "blue";
  if (levelCode.includes("district") || levelCode.includes("county")) return "green";
  return "default";
};

/** 合作状态 dict_code → Tag 颜色 */
export const getAgentCooperationTagColor = (statusCode: string): string => {
  if (statusCode.includes("active") || statusCode.includes("cooperating")) return "success";
  if (statusCode.includes("suspend")) return "warning";
  if (statusCode.includes("termin") || statusCode.includes("cancel")) return "error";
  return "default";
};

/** 代理等级 Tag 配色 */
export const AGENT_LEVEL_THEME: Record<string, { color: string; gradient: string }> = {
  agentLevel_province: {
    color: "orange",
    gradient: "bg-linear-to-br from-orange-400 via-orange-500 to-amber-500",
  },
  agentLevel_city: {
    color: "blue",
    gradient: "bg-linear-to-br from-blue-400 via-blue-500 to-indigo-500",
  },
  agentLevel_district: {
    color: "green",
    gradient: "bg-linear-to-br from-emerald-400 via-emerald-500 to-teal-500",
  },
};

/** 合作状态 Tag 配色与文案 */
export const AGENT_STATUS_THEME: Record<string, { color: string }> = {
  agentCoopStatus_active: { color: "success" },
  agentCoopStatus_paused: { color: "warning" },
  agentCoopStatus_terminated: { color: "error" },
};
